import React, { useMemo, useState, useEffect } from "react"

import {
  Container,
  CardBody,
  Card,
  ModalBody,
  ModalHeader,
  Modal,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import { useNavigate } from "react-router-dom"

import moment from "moment"
import { axiosbaseurl } from "configure"
import Loader from "components/Common/Loader"
import PermittedComponent from "components/Common/PermittedComponent"
import { usePermissionData } from "AppContext"
import CommonTable from "components/Common/CommonTable"

const EmailLogs = () => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getLogsData = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(`/email-logs`)
        if (response.data.success) {
          settable_data(
            response.data.data.map(c => ({
              ...c,
              clientName: c.client?.clientName,
              clientEmail: c.client?.email,
            }))
          )
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getLogsData()
  }, [])

  document.title = "Email Logs | Peacock Accountants Limited"

  return (
    <>
      {loading && <Loader />}
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Email Logs"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <TableComponent table_data={table_data} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data }) => {
  const [viewShow, setViewShow] = useState(false)
  const [bodydata, setbodydata] = useState("")

  const { checkAccess } = usePermissionData()
  const module_id = 27

  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: "text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Email Subject	",
        accessor: "subject",
        disableFilters: true,
        filterable: true,
      },

      {
        Header: "Client Name",
        accessor: "clientName",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Delivered To",
        accessor: "deliveredTo",
        className: " text-center",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => (
          <span>{cellProps?.row?.original?.deliveredTo || "--"}</span>
        ),
      },
      {
        Header: "Related",
        accessor: "relatedTo",
        disableFilters: true,
        className: " text-center",
        filterable: true,
        Cell: cellProps => (
          <span>{cellProps.row.original.relatedTo || "--"}</span>
        ),
      },
      // {
      //   Header: "Email Type	",
      //   accessor: "emailStatus",
      //   disableFilters: true,
      //   filterable: true,
      // },
      {
        Header: "Status",
        disableSort: true,
        accessor: "deliveryStatus",
        disableFilters: true,
        className: " text-center",
        filterable: true,
      },
      {
        Header: "Delivered At",
        accessor: "createdAt",
        disableFilters: true,
        filterable: true,
        // className: " text-center",
        Cell: cellProps => {
          return (
            <div>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </div>
          )
        },
      },
      {
        Header: "Action",
        disableFilters: true,
        disableSort: true,
        accessor: "view",
        className: "col-1 text-center",
        Cell: cellProps => {
          return (
            <div>
              <button
                onClick={() => {
                  setViewShow(true)
                  setbodydata(cellProps.row.original.body)
                }}
                className="btn btn-success bg-green  btn-sm me-2"
              >
                <i className="fas fa-eye me-1"></i> View
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable columns={columns} data={data} heading={"Email Logs"}>
          <div>
            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        {/* Show Email Body */}
        <Modal
          size="lg"
          isOpen={viewShow}
          toggle={() => setViewShow(!viewShow)}
          centered={true}
        >
          <div className="modal-content">
            <ModalHeader className="w-100 bg-primary">
              <div className="d-flex align-items-center justify-content-between w-100 ">
                <h4 className="mb-0 text-white"> Email Body </h4>
                <div>
                  <button
                    type="button"
                    className="btn btn-danger ms-3"
                    onClick={() => setViewShow(!viewShow)}
                  >
                    <i className="fa fa-times me-2"></i> Close
                  </button>
                </div>
              </div>
            </ModalHeader>
            <ModalBody className="p-0">
              <div className="p-4">
                <div
                  dangerouslySetInnerHTML={{
                    __html: bodydata || "<div></div>",
                  }}
                />
              </div>
            </ModalBody>
          </div>
        </Modal>
      </PermittedComponent>
    </>
  )
}

export default EmailLogs
